// Date d'activation de la double authentification pour les clients courtiers
// (code SMS à chaque connexion, activée côté PASS/Gravitee) : 1er octobre 2026.
// À partir de cette date, les clients courtiers voient une popin bloquante
// tant que le numéro de téléphone est absent du dossier (la mise à jour passe
// obligatoirement par leur courtier).
export const MFA_ACTIVATION_DATE = '2026-10-01';
